"use strict";

exports.__esModule = true;
exports.HEADER_SHOW_DEFAULT = exports.HEADER_SIZE_500 = exports.HEADER_SIZE_400 = exports.HEADER_SIZE_300 = exports.HEADER_SIZE_200 = exports.HEADER_SIZE_100 = void 0;
var HEADER_SIZE_100 = 100;
exports.HEADER_SIZE_100 = HEADER_SIZE_100;
var HEADER_SIZE_200 = 200;
exports.HEADER_SIZE_200 = HEADER_SIZE_200;
var HEADER_SIZE_300 = 300;
exports.HEADER_SIZE_300 = HEADER_SIZE_300;
var HEADER_SIZE_400 = 400;
exports.HEADER_SIZE_400 = HEADER_SIZE_400;
var HEADER_SIZE_500 = 500;
exports.HEADER_SIZE_500 = HEADER_SIZE_500;
var HEADER_SHOW_DEFAULT = false;
exports.HEADER_SHOW_DEFAULT = HEADER_SHOW_DEFAULT;